<template>
  <div class="app">
    <BannerSection />
    <div grid-list-xs class="d-flex justify-center align-center py-6 py-md-10 accentDarkBlue">
    <div class="font-weight-bold white--text big-div-font">Download JUKNIS (Petunjuk Teknis) <a target="__blank" href="https://drive.google.com/file/d/1hHXpjo6BoDqu5kE_9Yb7yMtMRjyPlHDa/view?usp=sharing">di sini</a></div>
    </div>
    
    <!-- <BannerMajorSection /> -->
    <StepSection />
    <SyaratPendaftaranSection :cardWidth="cardWidth"/>
    <BerkasPendaftaranSection :cardWidth="cardWidth"/>
    <TimelineSection v-if="currentWave" :currentWave="currentWave" />
    <MajorSection
      v-if="currentWave || sw_status > 7"
      :hasRegister="hasRegister"
      :studentMajor="info.sw_jurusan"
      :id_status="sw_status"
    />
    <ClosedWaveSection v-if="!currentWave && sw_status < 8" />
    <div class="white-section"></div>
  </div>
</template>

<script>
import BannerSection from "../components/Home/BannerSection";
import StepSection from "../components/Home/StepSection";
import MajorSection from "../components/Home/MajorSection";
// import BannerMajorSection from "../components/Home/BannerMajorSection";
import TimelineSection from "../components/Home/TimelineSection";
import ClosedWaveSection from "../components/Home/ClosedWaveSection";
import SyaratPendaftaranSection from "../components/Informasi/Syarat.vue";
import BerkasPendaftaranSection from "../components/Informasi/BerkasPendaftaran.vue";

export default {
  name: "Home",
  props: [
    "date",
    "id",
    "hasRegister",
    "info",
    "currentWave",
    "sw_status"
  ],
  components: {
    BannerSection,
    // BannerMajorSection,
    StepSection,
    MajorSection,
    TimelineSection,
    ClosedWaveSection,
    SyaratPendaftaranSection,
    BerkasPendaftaranSection,
  },
  data: () => ({
    cardWidth: "another-card-width",
  }),
};
</script>

<style scoped>
.big-div-font {
  font-size: 1.3rem;;
  width: 84%;
}
.white-section {
  min-height: 200px;
}
</style>
